export const BACK_URL_GET_PARAM = 'back_url';
export const DESKTOP_WIDTH = 1280;
export const IS_LOGO_TEXT_SEPARATED = window.APP_CEMETERY_LOGO_TITLE || window.APP_CEMETERY_LOGO_SUBTITLE;

export const ApiResponseStatus = {
  UNAUTHORIZED: 401,
};

export const EMAIL_REGEX = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;

export const ErrorText = {
  EMAIL_FORMAT_INVALID_ERROR: 'This is not a valid email address',
  FIELD_IS_REQUIRED: 'This field is required',
  FAILED_AUTH: 'Login or password is incorrect',
};

export const InventoryAuthData = {
  USER: 'afs_inventory_user',
  TOKEN: 'afs_inventory_jwt',
};

export const LoginText = {
  DESKTOP: 'Please sign in',
  MOBILE: 'Please enter your username and password',
};

export const SalesAuthData = {
  USER: 'afs_sales_user',
  TOKEN: 'afs_sales_jwt',
};

export const ArrangementsAuthData = {
  USER: 'afs_arrangements_user',
  TOKEN: 'afs_arrangements_jwt',
};

export const Title = {
  DESKTOP: 'Cemetery Workstation',
  MOBILE: 'Login',
};

export const AppRoute = {
  LOGOUT_PAGE_ROUTE: '/logout',
  MAIN_PAGE_ROUTE: '/',
};

export const LogoLocation = {
  BACKGROUND: 'background',
  HEADER: 'header',
};

export const PUBLIC_URL = process.env.PUBLIC_URL || '';

export const LOCALES = Array.isArray(window.LOCALES) ? window.LOCALES : [];
export const DEFAULT_LOCALE = LOCALES[0];
export const IS_WITH_LOCALIZATION = LOCALES.length;
export const IS_MAIN_PAGE_LOGO_HIDDEN = window.HIDE_LOGOS_ON_MAIN_PAGE;